module.exports = __webpack_public_path__ + "static/NimbusSanL-Regu-0b03b16fdc5ab63335f5fb9558b64e47.woff2";